<template>
    <div id="ai-colour-extract-v2-from-modal" class="hidden modal-new">
        <btnClose />
        <span class="title">AI Colour Extract From</span>

        <span v-if="!projectTree.length" class="description my-auto">Please save a Match of a reference image first to use the AI Colour Extract tool</span>

        <div v-else class="modal-body-container">
            <div class="assets-container">
                <div v-for="asset of applyGradeFromMatchProjectTree" :key="asset.key" class="asset-container">
                    <v-lazy>
                        <Thumbnail :item="asset" @click.native="selectedItem = asset"
                                   :class="{ '--selected': selectedItem && selectedItem.key == asset.key }"
                        />
                    </v-lazy>
                    <span class="asset-name">{{ nicename(asset.name) }}</span>
                </div>
            </div>
        </div>

        <div class="buttons-continer">
            <button :class="{ '--disabled': inProcess }" :disabled="!selectedItem" class="modal-btn --primary"
                    type="button" @click="onConfirm($event)"
            >
                <v-progress-circular v-if="inProcess" color="#fff" indeterminate size="18" width="3"
                ></v-progress-circular>
                <span v-else>Apply</span>
            </button>
            <button class="modal-btn --cancel" type="button" @click="onCancel">Cancel</button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import btnClose from "@/components/app/buttons/modal/Close";
import FilenameMixin from "@/mixins/Filename";
import Thumbnail from "@/components/app/media/Thumbnail";

export default {
    name: "AIColourExtractFrom",
    mixins: [FilenameMixin],

    components: {
        btnClose,
        Thumbnail
    },

    data() {
        return {
            expanded: 0,
            selectedItem: null,
            inProcess: false,
        };
    },

    computed: {
        ...mapState("Projects", ["action", "image", "applyGradeFromMatchProjectTree"]),
        ...mapGetters("Projects", ["thumbnail"]),

        projectTree() {
            return this.applyGradeFromMatchProjectTree;
        },
    },

    methods: {
        ...mapActions("Helpers", ["revokeObjectURL"]),

        nicename(name, stripTimestampOnly = false) {
            if (stripTimestampOnly) return this.stripTimestamp(name);
            else return this.stripTimestampAndExtension(name);
        },

        async onConfirm($event) {
            if (this.inProcess) return;

            if (this.action.action == "AIColourExtractFrom" && this.action.id !== this.image) {
                await this.$root.projectTree.onFileSelection($event, this.action.data.file.bin_id, this.action.data.file);
            }

            this.inProcess = true;
            this.$store.dispatch("Loader/showProgressBar", "indeterminate");

            // When adding from file's contextual menu
            if (this.$store.state.Projects.action.action == "AIColourExtractFrom") {
                await window._Adjustments.AIColourExtractV2.addBlock();
            }

            await window._Adjustments.AIColourExtractV2.setSampleFile(this.selectedItem);

            if (lutify.activeSidebarContainer !== "blocks") {
                this.$store.dispatch('UI/setLeftColumn', 'appliedBlocks')
                UI.scrollToBlock(lutify.activeBlock);
            }

            this.$store.dispatch("Loader/showProgressBar", false);
            this.inProcess = false;
            this.selectedItem = null;

            window.UI.hideModal();
        },

        onCancel() {
            this.selectedItem = null;
            window.UI.hideModal();
        },
    },
};
</script>

<style lang="scss">
#ai-colour-extract-v2-from-modal {
    width: 50%;
    height: 80%;

    .modal-body-container {
        margin-bottom: 50px;
        overflow-y: scroll;
        scrollbar-color: #989898 transparent;
        scrollbar-width: thin;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #989898;
            border-radius: 50px;
        }
    }

    .v-tabs {
        margin-bottom: 25px;
    }

    .v-tab {
        font-size: 11px;
        color: var(--font-default-color);

        &.v-tab--active {
            color: white;
        }

        &:before {
            background: transparent;
        }
    }

    .v-expansion-panel {
        background: transparent;
        color: inherit;

        &:before {
            display: none;
        }

        .v-expansion-panel-header {
            padding: 0;
            min-height: auto;
            flex-direction: row-reverse;
            // margin-bottom: 10px;

            &:before {
                display: none;
            }

            span {
                font-size: 12px;
                font-weight: bold;
            }

            .v-expansion-panel-header__icon i {
                font-size: 18px;
                color: var(--font-default-color);
            }
        }

        .v-expansion-panel-content__wrap {
            margin-bottom: 60px;
            padding: 0;
        }
    }

    .bin-container {
        &:not(:first-of-type) {
            margin-top: 15px;
        }
    }

    .assets-container {
        margin-top: 15px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        padding-right: 10px;
        // margin-left: -3px;
        // margin-right: -3px;

        .asset-container {
            min-width: 0;

            .file-thumbnail {
                border-radius: var(--thumbnail-lg-border-radius);
                border: 3px solid transparent;

                &.--selected {
                    border: 3px solid var(--primary);
                }
            }

            .asset-name {
                line-height: 22px;
                font-size: 12px;
                height: 22px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: block;
            }
        }
    }

    .buttons-continer {
        margin-top: auto;
    }
}

#project-tree-copy-candidate-from {
    margin-bottom: 50px;
    height: 300px;
    // scrollbar-width: none;
    background: transparent;
    color: #989898;
    font-size: 1rem !important;

    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-color: #989898 transparent;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #989898;
        border-radius: 50px;
    }

    .v-icon {
        color: #989898;
    }

    .v-treeview-node__label {
        line-height: 1;
    }

    .v-treeview-node__root:before,
    .v-treeview-node__toggle {
        transition: none;
    }

    .v-treeview-node__toggle:after {
        display: none;
    }

    .thumbnail-container {
        width: 50px;
        height: 35px;
        margin-right: 5px;
        // .file-thumbnail {
        // 	width: 100%;
        // 	height: 100%;
        // 	object-fit: contain;
        // 	padding: 3px 0;
        // 	// border-radius: var(--thumbnail-sm-border-radius);
        // }
    }
}
</style>
